import { Star } from 'lucide-react';

import { Rating } from '@/components/ui/Rating';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'rating',
  renderInput: ({ field, value, onChange }) => (
    <Rating
      value={(value as number) || 0}
      onChange={onChange}
      max={(field as { rating_max?: number }).rating_max || 5}
      icon={
        ((field as { rating_icon?: string }).rating_icon as 'star' | 'heart' | 'thumbsup') || 'star'
      }
    />
  ),
  renderCell: (field, value) => {
    if (value == null) return '—';
    const num = Number(value);
    const max = (field as { rating_max?: number }).rating_max || 5;
    return (
      <div className="flex items-center gap-0.5">
        {Array.from({ length: max }).map((_, i) => (
          <Star
            key={i}
            className={`h-3.5 w-3.5 ${i < num ? 'fill-yellow-400 text-yellow-400' : 'text-border-primary'}`}
          />
        ))}
        <span className="ml-1 text-xs text-text-tertiary">
          ({num}/{max})
        </span>
      </div>
    );
  },
  validate: (value, field) => {
    if (value == null) return null;
    const num = Number(value);
    const max = (field as { rating_max?: number }).rating_max || 5;
    if (isNaN(num) || num < 0 || num > max) return `Ocena musi być od 0 do ${max}`;
    return null;
  },
  defaultValue: 0,
});
